import React from "react";
import { Flex, Box, TouchableOpacity, Text, H3, FontAwesome, Image } from "@atoms";
import { renderIf } from "@services";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  title: string;
  description: string;
  linkId: string;
  onClick: (linkId: string, locationId?: string) => void;
  giveSentence: string;
  showBorder?: boolean;
  locationId?: string;
  leftImage: string;
}

// == Constants ============================================================

const DEFAULT_PROPS = {
  showUpTo: false,
  showBorder: false,
};

const CIRCLE_SIZE = "60px";

// == Component ============================================================

const BrandModalLinkListItem = ({
  title,
  description,
  linkId,
  onClick,
  giveSentence,
  showBorder,
  leftImage,
  locationId,
}: IProps) => {
  // const renderPercentCircle = () => {
  //   return (
  //     <Flex
  //       alignItems="center"
  //       bg="white"
  //       border="silver"
  //       borderRadius="100%"
  //       flexDirection="column"
  //       height={CIRCLE_SIZE}
  //       justifyContent="center"
  //       p={1}
  //       textAlign="center"
  //       width={CIRCLE_SIZE}
  //     >
  //       <Text color="primary">{giveAmount}</Text>
  //     </Flex>
  //   );
  // };

  return (
    <TouchableOpacity
      containerProps={{ style: { width: "100%" } }}
      onTouch={() => onClick(linkId, locationId)}
    >
      <Flex alignItems="center" borderTop={showBorder ? "silver" : ""} py={3}>
        <Box alignSelf="flex-start" flex="0 0 auto" mr={3}>
          <Image alt={title} src={leftImage} width={CIRCLE_SIZE} />
        </Box>
        <Box>
          <H3>{title}</H3>
          <Text color="primary" display="block" my={1}>
            {giveSentence}
          </Text>
          <Text>{description}</Text>
        </Box>
        <Flex alignItems="center" flex="1 0 auto" justifyContent="flex-end" ml={4} px={3}>
          <Text color="primary">
            <FontAwesome icon="chevron-right" />
          </Text>
        </Flex>
      </Flex>
    </TouchableOpacity>
  );
};

BrandModalLinkListItem.defaultProps = DEFAULT_PROPS;
export default BrandModalLinkListItem;
